export default __webpack_public_path__ + "static/media/kyc-lowrisk-by-audit-sc.3cdce32c.png";